import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_AlertMaintenance } from "../shared/data.service";

import { wsAlertMaintenanceBroadcastAlertEditParm } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertEditInfo } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertEditSchoolInfo } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertTargetInfo } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertAddUpdateParm } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertAddUpdateSchoolInfo } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { ViewChild } from "@angular/core";

@Component({
	selector: "app-root",
	templateUrl: "./editbroadcastalert.component.html",
	styleUrls: ["./editbroadcastalert.component.css"],
	providers: [ConfirmationService],
})
export class EditBroadcastAlertComponent implements OnInit, OnDestroy {
	@ViewChild("dtAssigned") dtAssigned: Table;
	@ViewChild("filterSelected", { static: false })
	public filterSelected: Dropdown;
	@ViewChild("filterSelectable", { static: false })
	public filterSelectable: Dropdown;

	constructor(
		private dataService: DataService_AlertMaintenance,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public AlertID: number = -1;

	public BroadcastAlertData: wsAlertMaintenanceBroadcastAlertEditInfo;
	public lstTargetItems: wsAlertMaintenanceBroadcastAlertTargetInfo[] = [];
	public SelectedTarget: wsAlertMaintenanceBroadcastAlertTargetInfo;
	public lstSchoolItems: wsAlertMaintenanceBroadcastAlertEditSchoolInfo[] = [];
	public isSelectAll: boolean = false;

	public rMessage: string = "";
	public rStartDate: Date = null;
	public rEndDate: Date = null;

	//	Filters
	public lstSelected: any = [];
	public lstSelectable: any = [];

	//	DataTable page counts
	public pagefirst: number = 0;
	public pagerows: number = 5;

	public CountAssigned: number = 0;
	public CountUnAssigned: number = 0;
	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.AlertID = this.dialogConfig.data.AlertID;

		let parm: wsAlertMaintenanceBroadcastAlertEditParm = {
			UserID: this.UserID,
			AlertID: this.AlertID,
		};

		this.isBusy = true;
		this.dataService.AlertMaintenanceBroadcastAlertEditDataGet(parm).subscribe((data) => this.AlertMaintenanceBroadcastAlertEditDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceBroadcastAlertEditDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceBroadcastAlertEditDataGet_Complete(data: any) {
		this.BroadcastAlertData = data;

		this.lstTargetItems = this.BroadcastAlertData.TargetItems;
		this.lstSchoolItems = this.BroadcastAlertData.SchoolItems;
		this.rMessage = this.BroadcastAlertData.Message;

		if (this.BroadcastAlertData.StartDate == null) {
			this.rStartDate = null;
		} else {
			this.rStartDate = new Date(this.BroadcastAlertData.StartDate); // Must do new for this to work
		}

		if (this.BroadcastAlertData.EndDate == null) {
			this.rEndDate = null;
		} else {
			this.rEndDate = new Date(this.BroadcastAlertData.EndDate); // Must do new for this to work
		}

		//
		//	Select Default Target
		//
		this.SelectedTarget = this.lstTargetItems[0];

		this.lstTargetItems.forEach((item) => {
			if (item.BroadcastAlertTargetID == this.BroadcastAlertData.BroadcastAlertTargetID) {
				this.SelectedTarget = item;
			}
		});

		//
		//	Set Filter Lists
		//
		this.lstSelected = [];
		this.lstSelected.push({ IsSelected: true, IsSelectedDesc: "Assigned" });
		this.lstSelected.push({
			IsSelected: false,
			IsSelectedDesc: "UnAssigned",
		});

		this.lstSelectable = [];
		this.lstSelectable.push({
			IsSelectable: true,
			IsSelectableDesc: "Yes",
		});
		this.lstSelectable.push({
			IsSelectable: false,
			IsSelectableDesc: "No",
		});

		//
		//	Reset Filters
		//
		this.onClearFilters();

		//
		//	Refresh Assign Counts
		//
		this.onRefreshAssignCounts();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStartDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStartDateChange(val) {
		this.rStartDate = val;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEndDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onEndDateChange(val) {
		this.rEndDate = val;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onTargetChange
	//
	//-----------------------------------------------------------------------------------------------------
	onTargetChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClearFilters
	//
	//-----------------------------------------------------------------------------------------------------
	onClearFilters() {
		this.filterSelected.clear(null);
		this.filterSelectable.clear(null);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSelectAll
	//
	//-----------------------------------------------------------------------------------------------------
	onSelectAll(e: any) {
		this.lstSchoolItems.forEach((item) => {
			if (this.isSelectAll == true) {
				if (item.IsUserSelectable == true) {
					item.IsSelected = true;
				}
			} else {
				if (item.IsUserSelectable == true) {
					item.IsSelected = false;
				}
			}
		});

		//
		//	Clear filter so we see the changes
		//
		this.filterSelected.clear(null);
		this.filterSelectable.clear(null);

		//
		//	Refresh Assign Counts
		//
		this.onRefreshAssignCounts();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefreshAssignCounts
	//
	//-----------------------------------------------------------------------------------------------------
	onRefreshAssignCounts() {
		this.CountAssigned = 0;
		this.CountUnAssigned = 0;

		this.lstSchoolItems.forEach((item) => {
			if (item.IsSelected == true) {
				this.CountAssigned += 1;
			} else {
				this.CountUnAssigned += 1;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() {
		this.ErrorMessage = "";

		//
		// Validate Message
		//
		if (this.rMessage.length < 1) {
			this.ErrorMessage = "Message must be entered.";
			return;
		}

		//
		// Validate Dates
		//
		if (this.rStartDate == null || this.rEndDate == null) {
			this.ErrorMessage = "Start Date and End Date must be entered.";
			return;
		} else {
			if (this.rStartDate.getFullYear() < 1753 || this.rEndDate.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Start Date and End Date must be greater then 1/1/1753.";
				return;
			}

			if (this.rEndDate < this.rStartDate) {
				this.ErrorMessage = "End Date cannot be less then Start Date.";
				return;
			}
		}

		//
		// Validate School List
		//
		let IsAtLeast1SchoolSelected = false;

		this.lstSchoolItems.forEach((item) => {
			if (item.IsSelected == true) {
				IsAtLeast1SchoolSelected = true;
			}
		});

		if (IsAtLeast1SchoolSelected == false) {
			this.ErrorMessage = "You must select at least one school.";
			return;
		}

		//
		// Do the EDIT
		//
		let lstSelectedSchools: wsAlertMaintenanceBroadcastAlertAddUpdateSchoolInfo[] = [];

		this.lstSchoolItems.forEach((item) => {
			if (item.IsUserSelectable == true && item.IsSelected == true) {
				lstSelectedSchools.push({ SchoolID: item.SchoolID });
			}
		});

		let parm: wsAlertMaintenanceBroadcastAlertAddUpdateParm = {
			UserID: this.UserID,
			AlertID: this.AlertID,
			BroadcastAlertTargetID: this.SelectedTarget.BroadcastAlertTargetID,
			StartDate: this.rStartDate,
			EndDate: this.rEndDate,
			Message: this.rMessage,
			SchoolItems: lstSelectedSchools,
		};

		this.isBusy = true;
		this.dataService.AlertMaintenanceBroadcastAlertUpdate(parm).subscribe((data) => this.AlertMaintenanceBroadcastAlertUpdate_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceBroadcastAlertUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceBroadcastAlertUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
